import { adminSession, loyaltySession } from './session';
import { store } from '../store';
import { dispatchAdminSessionExpired } from './sessionExpiryEvents';

export const LOYALTY_TOKEN_KEY = 'loyalty_token';
export const LOYALTY_USER_KEY = 'loyalty_user';

function getSessionExpiryMessage(context = {}) {
  const state = store.getState();
  const roles = state.auth?.roles || [];
  const isWaiterOrShishaMaster = roles.includes('waiter') || roles.includes('shisha_master');

  if (!isWaiterOrShishaMaster) {
    return null;
  }

  const isQROperation =
    context.operation === 'qr_scan' ||
    context.operation === 'increment_hookah' ||
    (typeof window !== 'undefined' && window.location.pathname.includes('scan-qr'));

  if (roles.includes('waiter') && isQROperation) {
    return {
      message:
        '⚠️ ВНИМАНИЕ!\n\n' +
        'Вашата сесия е изтекла по време на операция със скениране на QR код.\n\n' +
        'Последната операция за добавяне на наргиле НЕ Е ЗАПИСАНА.\n\n' +
        'Моля, влезте отново и повторете операцията.',
      isQrWarning: true,
    };
  }

  return {
    message: 'Вашата сесия е изтекла.\n\nЩе бъдете пренасочени към страницата за вход.',
    isQrWarning: false,
  };
}

function isAdminLoginPath() {
  return typeof window !== 'undefined' && window.location.pathname === '/admin/login';
}

function isLoyaltyLoginPath() {
  return typeof window !== 'undefined' && (
    window.location.pathname === '/loyalty' ||
    window.location.pathname === '/loyalty/login'
  );
}

/**
 * Admin 401 / session expiry — optional dialog for waiters, then redirect.
 * @param {object} [context]
 */
export function handleAdminAuthFailure(context = {}) {
  if (context.redirectOnFailure === false) {
    adminSession.clear();
    return;
  }

  const expiryMessage = getSessionExpiryMessage(context);
  if (expiryMessage) {
    dispatchAdminSessionExpired(expiryMessage);
  }

  adminSession.clear();

  if (isAdminLoginPath()) {
    return;
  }

  // Delay redirect slightly so MUI dialog can render when shown
  const delay = expiryMessage ? 100 : 0;
  setTimeout(() => {
    window.location.href = '/admin/login';
  }, delay);
}

/**
 * @param {'admin' | 'loyalty'} realm
 * @param {object} [context]
 */
export function handleAuthFailure(realm, context = {}) {
  if (realm === 'admin') {
    handleAdminAuthFailure(context);
    return;
  }

  if (realm === 'loyalty') {
    loyaltySession.clear();
    if (context.redirectOnFailure !== false && !isLoyaltyLoginPath()) {
      window.location.href = '/loyalty/login';
    }
  }
}

export function isUnauthorizedError(error) {
  return (
    error?.status === 401 ||
    error?.response?.status === 401 ||
    error?.message === 'Authentication required' ||
    error?.message?.includes('Unauthenticated')
  );
}
